// extracted by mini-css-extract-plugin
export var filterIncDec = "_c7-0";
export var leftBorder = "_c7-1";
export var rightBorder = "_c7-2";
export var stringInput = "_c7-3";